<template>
	<el-drawer
		:title="title"
		:visible.sync="visible"
		:append-to-body="appendToBody"
		size="800px"
		:before-close="handleClose"
		:wrapperClosable="wrapperClosable"
		custom-class="addressManageDrawer drawer-template"
	>
		<div
			class="addressScrollBody"
			v-scroll-lazy-load="{
				loadData,
				distance: 100,
				delay: 1000,
				callback: fn => this.$once('hook:beforeDestroy', () => fn()),
			}"
		>
			<div class="mb-16 mt-16 ml-24">
				<el-button type="primary" icon="el-icon-plus" @click="handleAddRess">新增地址</el-button>
			</div>
			<Empty :size="180" v-if="!list.length && this.loadmore.status == 'nomore'">
				<p slot="desc" class="yx-color-text-primary font-h3-regular">暂无数据</p>
			</Empty>
			<div v-else>
				<Item
					v-for="item in list"
					:key="item.delivery_id"
					:delivery_id="delivery_id"
					:info="item"
					:isChoose="isChoose"
					@showAnchorInfo="showAnchorInfo"
					@editAddress="editAddress"
					@refresh="refresh"
					@useAddress="useAddress"
					class="mb-12"
				/>

				<p class="pt-4 pb-20 font-h4-regular yx-color-text-regular flex-center">
					<i class="el-icon-loading fz-16 mr-4" v-if="loadmore.status === 'loading'"></i>
					<span :class="loadmore.status === 'nomore' ? 'nomore' : ''">{{ loadmore.text }}</span>
				</p>
			</div>
		</div>
		<AnchorViewer ref="anchorViewer" />
		<AddAdressDraw ref="addAdressDraw" @refreshList="refreshList" />
	</el-drawer>
</template>
<script>
import Item from './components/item';
import AnchorViewer from './components/anchorViewer';
import { addressManageList } from '@/api/common';
import AddAdressDraw from '@/components/business/addAdressDraw';
export default {
	props: {},
	data() {
		return {
			title: '团长地址', // 弹窗标题
			visible: false, // 弹窗显隐
			pageInfo: {
				page_index: 1,
				page_size: 20,
			},
			loadmore: {
				text: '加载更多',
				status: 'pending',
			},

			teamInstitutionId: '',
			delivery_id: '',

			list: [],

			isChoose: false,
		};
	},
	created() {
		this.initData();
	},
	methods: {
		useAddress(info) {
			this.$emit('setAddress', info);
			this.handleClose();
		},
		// 主动显示弹窗
		show(teamInstitutionId, delivery_id) {
			this.teamInstitutionId = teamInstitutionId;
			this.delivery_id = delivery_id;
			this.isChoose = !!delivery_id;
			this.visible = true;
			this.getList(false);
		},
		refresh() {
			this.getList(false);
		},
		refreshList(info) {
			if (info.v == 'edit') {
				return this.refresh();
			}
			if (this.isChoose) {
				return this.useAddress(info);
			}
			this.getList(false);
		},
		// 清空数据并关闭弹窗
		handleClose() {
			this.visible = false;
			// this.$emit('refreshList');
		},
		// 不需要响应式的数据进行初始化设置
		initData() {
			// 抽屉是否添加到body节点下
			this.appendToBody = true;
			// 点击蒙版是否关闭
			this.wrapperClosable = true;
		},
		showAnchorInfo(id) {
			this.$refs['anchorViewer'].show(id);
		},
		loadData() {
			// 有下一页才会请求接口
			if (this.loadmore.status === 'nomore') {
				return;
			}
			this.pageInfo.page_index++;
			this.loadmore = {
				text: '加载中...',
				status: 'loading',
			};
			this.getList(true);
		},
		async getList(loadMore) {
			if (!loadMore) {
				this.pageInfo.page_index = 1;
			}
			if (loadMore && this.loadmore.status === 'nomore') {
				return;
			}
			let data = await addressManageList({ ...this.pageInfo, teamInstitutionId: this.teamInstitutionId, delivery_id: this.delivery_id });
			// 加载更多并且还有下一页才会加载
			if (loadMore) {
				this.list = this.list.concat(data.list);
			} else {
				this.list = data.list;

			}
			this.loadmore = !data.page.page_has
				? {
						text: '已经到底了',
						status: 'nomore',
				  }
				: {
						text: '加载更多',
						status: 'pending',
				  };
		},

		handleAddRess() {
			this.$refs.addAdressDraw.show({
				tzId: this.teamInstitutionId,
				drId: '',
				role: 'isTz',
				v: 'add',
				delivery_id: '',
			});
		},
		editAddress(addressInfo) {
			this.$refs.addAdressDraw.show({
				tzId: this.teamInstitutionId,
				drId: '',
				role: 'isTz',
				v: 'edit',
				delivery_id: addressInfo.delivery_id,
				addressInfo,
			});
		},
	},
	components: {
		Item,
		AnchorViewer,
		AddAdressDraw,
		
	},
	beforeDestroy() {},
};
</script>

<style lang="less">
.addressManageDrawer {
	.el-drawer__body {
		background: @color-gy2;
		padding: 0px 0px 0px !important;
	}
}
.addressScrollBody {
	height: 100%;
	overflow-y: auto;
}
</style>
